import React from 'react';
import ReactTooltip from 'react-tooltip';
import { useTheme } from 'styled-components';

const ThemedTooltip = (props) => {
  const theme = useTheme();
  return (
    <ReactTooltip
      {...props}
      backgroundColor={theme.card}
      textColor={theme.text}
      borderColor={theme.border}
      arrowColor={theme.card}
    />
  );
};

export default ThemedTooltip;
